<div *ngIf="loading" class="schedule-state schedule-loading" role="status" aria-live="polite">
  <span class="schedule-loading-indicator" aria-hidden="true"></span>
  <span>Buscando horários disponíveis...</span>
</div>

<div *ngIf="!loading && hoursLoadMessage" class="schedule-state schedule-error-state" role="alert">
  <mat-icon aria-hidden="true">event_busy</mat-icon>
  <span>{{ hoursLoadMessage }}</span>
  <button *ngIf="canRetryHoursLoad" mat-stroked-button color="primary" type="button" (click)="loadCalendarData()">
    Tentar novamente
  </button>
</div>

<ng-container *ngIf="!loading && !hoursLoadMessage">
  <div *ngIf="firstAvailableLabel as firstAvailable" class="next-available-summary" role="status">
    <mat-icon aria-hidden="true">event_available</mat-icon>
    <span>Próximo horário mostrado: <strong>{{ firstAvailable }}</strong></span>
  </div>

  <div *ngIf="!hasAvailableTime" class="schedule-state schedule-empty-state" role="status">
    <mat-icon aria-hidden="true">event_busy</mat-icon>
    <span>Não há horários livres entre as datas exibidas. Use as setas para consultar outras datas.</span>
  </div>

  <div class="schedule-grid-wrapper">
    <button type="button" class="arrow left" [disabled]="!canGoToPreviousWeek" aria-label="Semana anterior" (click)="goToPreviousWeek()">
      &#9664;
    </button>

    <div class="schedule-grid" [ngClass]="{
      'animating-left': animationDirection === 'left',
      'animating-right': animationDirection === 'right'
    }">
      <div class="day-column" *ngFor="let date of dates">
        <div class="day-header">
          <div>{{ date.day }}</div>
          <div>{{ date.date }}</div>
        </div>

        <ng-container *ngIf="isByOrder">
          <div *ngFor="let range of availability[date.fullDate] || []" class="hour-cell">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              *ngIf="isAvailableByOrder(date.fullDate, range)"
              class="hour-btn-order bt-horario"
              [attr.aria-label]="'Agendar ' + date.day + ', ' + date.date + ' no período ' + range"
              [ngClass]="{ selected: isSelectedByOrder(date.fullDate, range) }"
              (click)="selectHourByOrder(date.fullDate, range)"
            >
              {{ range }}
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="!isByOrder">
          <div
            *ngFor="let hour of (availability[date.fullDate] || []).slice(0, expanded ? availability[date.fullDate]?.length : 5)"
            class="hour-cell"
          >
            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="bt-horario alert-info"
              [attr.aria-label]="'Agendar ' + date.day + ', ' + date.date + ' às ' + hour"
              [ngClass]="{ available: isAvailable(date.fullDate, hour), selected: isSelected(date.fullDate, hour) }"
              [disabled]="!isAvailable(date.fullDate, hour)"
              (click)="selectHour(date.fullDate, hour)"
            >
              {{ hour }}
            </button>
          </div>
        </ng-container>

        <div class="hour-cell" *ngIf="!availability[date.fullDate]?.length">
          <span class="unavailable-label">Sem horários</span>
        </div>
      </div>
    </div>

    <button type="button" class="arrow right" aria-label="Próxima semana" (click)="goToNextWeek()">
      &#9654;
    </button>
  </div>

  <div class="expand-all-toggle" *ngIf="hasMoreThanFiveSlots() && !isByOrder">
    <button type="button" class="toggle-btn" (click)="toggleExpandAll()">
      {{ expanded ? 'Ver menos' : 'Ver mais horários' }}
    </button>
  </div>
</ng-container>
